/** @jsx jsx */
import { MoviePageContentProps } from "gatsby-theme-movie-pages";
import React, { memo } from "react";
import { jsx } from "theme-ui";

import Header from "./Header";

const MoviePageContent: React.FC<MoviePageContentProps> = ({
  movie,
  movieSchedule,
  selectedTheater,
}) => {
  if (!movie) {
    return null;
  }

  return (
    <Header
      movie={movie}
      movieSchedule={movieSchedule}
      selectedTheater={selectedTheater}
    />
  );
};

export default memo(MoviePageContent);
